import z from 'zod';
import { firmSubscriptionStatusValue } from '../firm-subscription-status';
import { billingPeriodValue, subscriptionPlanValue, } from '../value-objects/subscription-enums';
export const firmSubscriptionEntrySchema = z.object({
    billingPeriod: billingPeriodValue.nullable().optional(),
    commitmentEndDate: z.string().nullable(),
    lastSuccessfulPaymentDate: z.string().nullable(),
    nextRenewalDate: z.string().nullable(),
    plan: subscriptionPlanValue,
    subscriptionDate: z.string().nullable(),
    subscriptionStatus: firmSubscriptionStatusValue,
});
export const firmSubscriptionEntriesSchema = z.array(firmSubscriptionEntrySchema);
//# sourceMappingURL=firm-subscription-entry.js.map